import React from "react";
import { Breadcrumb } from "../../../atoms/breadcrumb";
import { PAGE_NAME, ROUTE } from "../../../../constants/constants";
import { Dropdown } from "../../../atoms/dropdown";
import { Icon } from "../../../atoms/icon";
import { Divider } from "../../../atoms/divider";
import { Pagination } from "../../../molecules/pagination";
import { useUnresponsiveUsersListQuery } from "../../../../store/reports/reportSlice";
import { usePaginationHook } from "../../../molecules/pagination/usePaginationHook";
import { Input } from "../../../atoms/input";
import { capitalizeFirstCharacter, formattedDateTime, isValidDate } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { MultipleDropdown } from "../../../atoms/multipleDropdown";
import { DropdownOptionsType } from "../../../../types";
import { Skeleton } from "../../../atoms/skeleton";
import { Loader } from "../../../atoms/loader";

const SaaSToolUnresponsiveUsers = () => {
    const pageClassName = "p-saasToolUnresponsiveUsers";
    const navigate = useNavigate();
    const ref = React.useRef<HTMLDivElement>(null);
    const [isShowFilter, setShowFilter] = React.useState(false);

    const [filter, setFilter] = React.useState({
        duration: {
            label: "Please select",
            value: "0",
        },
        toolNames: [] as { label: string; value: string }[],
    });

    const [query, setQuery] = React.useState({
        current: 1,
        limit: 20,
        search: "",
        duration: 0,
        toolNames: [] as string[],
    });
    const [search, setSearch] = React.useState("");

    const options = [
        {
            label: "1 month",
            value: 1,
        },
        {
            label: "3 months",
            value: 3,
        },
        {
            label: "6 months",
            value: 6,
        },
        {
            label: "12 months",
            value: 12,
        },
    ];

    React.useEffect(() => {
        const timer = setTimeout(() => {
            setQuery({ ...query, current: 1, search: search });
        }, 500);
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const pageChangeHandler = (page: number) => {
        setQuery({ ...query, current: page });
    };

    const limitChangeHandler = (limit: number) => {
        setQuery({ ...query, limit: limit });
    };

    const searchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
        setQuery({ ...query, current: 1 });
    };

    const { data, isLoading, isFetching, isSuccess } = useUnresponsiveUsersListQuery({
        search: query.search,
        limit: query.limit,
        current_page: query.current,
        tool_names: JSON.stringify(query.toolNames),
        duration: query.duration,
    });

    const {
        totalData,
        handleFirstPage,
        handlePrevPage,
        handleLastPage,
        handleNextPage,
        renderPageNumbers,
    } = usePaginationHook({
        totalNumberOfData: data?.result?.total,
        perPage: query.limit,
        setCurrentPage: pageChangeHandler,
        currentPage: query.current,
        className: "m-pagination",
    });

    const filteredFunction = (query: any) => {
        if (query.duration !== 0 && query.toolNames.length > 0) {
            return (
                <p className={`${pageClassName}__header__title`}>
                    Filtered By {query.duration} month{query.duration > 1 && "s"} and{" "}
                    {query.toolNames
                        .map((item: string) => capitalizeFirstCharacter(item))
                        .join(", ")}
                </p>
            );
        } else if (query.duration !== 0) {
            return (
                <p className={`${pageClassName}__header__title`}>
                    Filtered By {query.duration} month{query.duration > 1 && "s"}
                </p>
            );
        } else if (query.toolNames.length > 0) {
            return (
                <p className={`${pageClassName}__header__title`}>
                    Filtered By {query.toolNames
                        .map((item: string) => capitalizeFirstCharacter(item))
                        .join(", ")}
                </p>
            );
        }
    };

    return (
        <div className={pageClassName}>
            <Breadcrumb />
            <p className={`${pageClassName}__title`}>{PAGE_NAME.UNRESPONSIVE_USERS}</p>
            <div className={`${pageClassName}__container`}>
                <div className={`${pageClassName}__header`}>
                    <div className={`${pageClassName}__search`}>
                        <Input
                            placeholder="Search"
                            onChange={(e) => {
                                searchHandler(e);
                                handleFirstPage();
                            }}
                            value={search}
                        />
                    </div>

                    {filteredFunction(query)}
                    <div className={`${pageClassName}__header__combo`}>
                        {/* <button
                            onClick={() => viewTypeHandler("grid")}
                            className={`${pageClassName}__header__combo__button ${viewType === "grid" && pageClassName
                                }__header__combo__button--active`}
                            title="Grid"
                        >
                            <Icon icon="grid" size="primary" />
                        </button>
                        <button
                            onClick={() => viewTypeHandler("list")}
                            className={`${pageClassName}__header__combo__button ${viewType === "list" && pageClassName
                                }__header__combo__button--active`}
                            title="List"
                        >
                            <Icon icon="list" size="primary" />
                        </button> */}
                        <div
                            className={`${pageClassName}__header__combo__filter`}
                            ref={ref}
                        >
                            <button
                                onClick={() => setShowFilter(!isShowFilter)}
                                className={`${pageClassName}__header__combo__button`}
                                title="Filter"
                            >
                                <Icon icon="filter" size="primary" />
                            </button>
                            <div
                                className={`${pageClassName}__dropdown ${isShowFilter && pageClassName
                                    }__dropdown--show`}
                            >
                                {/* <div className={`${pageClassName}__dropdown__options`}>
                                    {options.map((item, index) => (
                                        <p
                                            key={index}
                                            className={`${pageClassName}__dropdown__options__item ${filter.duration === item.value && pageClassName
                                                }__dropdown__options__item--active`}
                                            onClick={() => {
                                                setFilter({ ...filter, duration: item.value })
                                            }}
                                        >
                                            {item.label}
                                        </p>
                                    ))}
                                </div> */}

                                <Dropdown
                                    placeholder="Select Duration"
                                    options={options}
                                    selected={filter.duration}
                                    onClickChange={(value) =>
                                        setFilter({
                                            ...filter,
                                            duration: value as { label: string; value: string },
                                        })
                                    }
                                    isBordered
                                    isIcon

                                />

                                <MultipleDropdown
                                    placeholder="Select Tools"
                                    options={[
                                        { label: "Okta", value: "okta" },
                                        { label: "YouTrack", value: "youtrack" },
                                        { label: "Box", value: "box" },
                                        { label: "Confluence", value: "confluence" },
                                        { label: "Gitlab", value: "gitlab" },
                                        { label: "Miro", value: "miro" },
                                        { label: "GCP", value: "gcp" },
                                        { label: "AWS", value: "aws" },
                                    ]}
                                    value={filter.toolNames as { label: string; value: string }[]}
                                    dropdownHandler={(value: DropdownOptionsType[]) =>
                                        setFilter({
                                            ...filter,
                                            toolNames: value as { label: string; value: string }[],
                                        })
                                    }
                                />
                                <div className={`${pageClassName}__dropdown__submit`}>
                                    <button
                                        onClick={() => {
                                            setQuery({
                                                ...query,
                                                current: 1,
                                                duration: parseInt(filter.duration.value),
                                                toolNames: filter.toolNames.map((item) => item.value),
                                            });
                                            setShowFilter(false);
                                            handleFirstPage();
                                        }}
                                    >
                                        Apply
                                    </button>
                                    <button
                                        onClick={() => {
                                            setFilter({
                                                ...filter,
                                                duration: { label: "Please select", value: "0" },
                                                toolNames: [],
                                            });
                                            setQuery({
                                                ...query,
                                                current: 1,
                                                duration: 0,
                                                toolNames: [],
                                            });
                                            setShowFilter(false);
                                            handleFirstPage();
                                        }}
                                    >
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {data?.result?.total !== 0 && (
                    <div className={`${pageClassName}__pagination`}>
                        <div className={`${pageClassName}__pagination__limit`}>
                            <p>Display</p>
                            <div className={`${pageClassName}__pagination__dropdown`}>
                                <Dropdown
                                    options={[
                                        { label: "20", value: 20 },
                                        { label: "50", value: 50 },
                                        { label: "100", value: 100 },
                                    ]}
                                    selected={{ label: query.limit, value: query.limit }}
                                    onClickChange={(e) => {
                                        limitChangeHandler(e.value as number);
                                        handleFirstPage();
                                    }}
                                    isBordered
                                    isIcon

                                />
                            </div>
                        </div>
                        <div className={`${pageClassName}__pagination__number`}>
                            {data?.result?.total ? (
                                <p>
                                    Show {data?.result?.from} -{" "}
                                    {data?.result?.from + query.limit - 1 < data?.result?.total
                                        ? data?.result?.from + query.limit - 1
                                        : data?.result?.total}{" "}
                                    of {data?.result?.total}
                                </p>
                            ) : (
                                <p>Show 00 - 00 of 00</p>
                            )}
                        </div>

                        <div className={`${pageClassName}__pagination__nav`}>
                            {data?.result?.total > query.limit && (
                                <Pagination
                                    totalData={totalData}
                                    page={query.current}
                                    handleFirstPage={handleFirstPage}
                                    handlePrevPage={handlePrevPage}
                                    handleLastPage={handleLastPage}
                                    handleNextPage={handleNextPage}
                                    renderPageNumbers={renderPageNumbers}
                                />
                            )}
                        </div>
                    </div>
                )}


                <Divider />
                <Loader isLoading={isFetching && isSuccess}>
                    <div className={`${pageClassName}__content`}>
                        {isLoading
                            ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item: any) => (
                                <div className={`${pageClassName}__skeleton__container`}>
                                    <div className={`${pageClassName}__skeleton__data`}>
                                        <div className={`${pageClassName}__skeleton__header`}>
                                            <div className={`${pageClassName}__skeleton__info`}>
                                                <p className={`${pageClassName}__skeleton__info__name`}>
                                                    <Skeleton height="small" />
                                                </p>
                                                <p className={`${pageClassName}__skeleton__info__email`}>
                                                    <Skeleton height="small" />
                                                </p>
                                            </div>
                                            <p className={`${pageClassName}__skeleton__serial`}>
                                                <Skeleton height="semiSmall" />
                                            </p>
                                        </div>
                                        <div className={`${pageClassName}__skeleton__saas`}>
                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item: any) => (
                                                <div
                                                    className={`${pageClassName}__skeleton__saas__tool`}
                                                    key={item}
                                                >
                                                    <div className={`${pageClassName}__skeleton__saas__logo`}>
                                                        <Skeleton height="small" />
                                                    </div>
                                                    <div className={`${pageClassName}__skeleton__saas__date`}>
                                                        <Skeleton height="small" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))
                            : data?.result?.data.map((item: any, index: number) => (
                                <div className={`${pageClassName}__content__container`}>
                                    <div className={`${pageClassName}__content__data`}>
                                        <div className={`${pageClassName}__content__header`}>
                                            <div className={`${pageClassName}__content__info`}>
                                                <p className={`${pageClassName}__content__info__name`}>
                                                    {item.firstName} {item.lastName}
                                                </p>
                                                <p className={`${pageClassName}__content__info__email`}>
                                                    {item.email}
                                                </p>
                                                <p className={`${pageClassName}__content__info__name`}>
                                                    PIC/Manager: <span>{item.picEmail}</span>
                                                </p>
                                            </div>
                                            <p className={`${pageClassName}__content__serial`}>
                                                {data?.result?.from + index}
                                            </p>
                                        </div>
                                        <div className={`${pageClassName}__content__saas`}>
                                            {item?.okta && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="Okta"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/okta.png")}
                                                            alt="okta"
                                                        />
                                                    </div>
                                                    {/* <p className={`${pageClassName}__content__saas__date ${isExpiredDate(item?.okta?.date, query.duration) ? pageClassName + '__content__saas__date--red' : ""}`}> */}
                                                    <p className={`${pageClassName}__content__saas__date `}>
                                                        {isValidDate(item?.okta?.date)
                                                            ? formattedDateTime(item?.okta?.date)
                                                            : item?.okta?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.box && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="Box"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/box.png")}
                                                            alt="box"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.box?.date)
                                                            ? formattedDateTime(item?.box?.date)
                                                            : item?.box?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.gitlab && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="GitLab"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/gitlab.png")}
                                                            alt="gitlab"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.gitlab?.date)
                                                            ? formattedDateTime(item?.gitlab?.date)
                                                            : item?.gitlab?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.youtrack && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="YouTrack"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/youtrack.png")}
                                                            alt="youtrack"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.youtrack?.date)
                                                            ? formattedDateTime(item?.youtrack?.date)
                                                            : item?.youtrack?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.confluence && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="Atlassian"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/atlassian.png")}
                                                            alt="atlassian"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.confluence?.date)
                                                            ? formattedDateTime(item?.confluence?.date)
                                                            : item?.confluence?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.confluence && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="Confluence"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/confluence.png")}
                                                            alt="confluence"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.confluence?.date)
                                                            ? formattedDateTime(item?.confluence?.date)
                                                            : item?.confluence?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.gcp && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="GCP"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/gcp.png")}
                                                            alt="gcp"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.gcp?.date)
                                                            ? formattedDateTime(item?.gcp?.date)
                                                            : item?.gcp?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.miro && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title={item?.miro?.license ? "Miro" : "Miro Guest"}
                                                    >
                                                        <img
                                                            src={require(`../../../../assets/saasToolLogo/miro.png`)}
                                                            alt="miro"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.miro?.date)
                                                            ? formattedDateTime(item?.miro?.date)
                                                            : item?.miro?.date}
                                                    </p>
                                                </div>
                                            )}
                                            {item?.aws && (
                                                <div className={`${pageClassName}__content__saas__tool`}>
                                                    <div
                                                        className={`${pageClassName}__content__saas__logo`}
                                                        onClick={() =>
                                                            navigate(ROUTE.OKTA_USER_LIST + `/${item.oktaUserId}`)
                                                        }
                                                        title="AWS"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/saasToolLogo/aws.png")}
                                                            alt="aws"
                                                        />
                                                    </div>
                                                    <p className={`${pageClassName}__content__saas__date`} >
                                                        {isValidDate(item?.aws?.date)
                                                            ? formattedDateTime(item?.aws?.date)
                                                            : item?.aws?.date}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </Loader>

                {data?.result?.total === 0 && (
                    <div className={`${pageClassName}__noData`}>
                        <div className={`${pageClassName}__noData__content`}>
                            <Icon icon="sadFace" size="tertiary" />
                            <p>No Data Found</p>
                        </div>
                    </div>
                )}
                {data?.result?.total !== 0 && (
                    <>
                        <Divider />
                        <div className={`${pageClassName}__pagination`}>
                            <div className={`${pageClassName}__pagination__limit`}>
                                <p>Display</p>
                                <div className={`${pageClassName}__pagination__dropdown`}>
                                    <Dropdown
                                        options={[
                                            { label: "20", value: 20 },
                                            { label: "50", value: 50 },
                                            { label: "100", value: 100 },
                                        ]}
                                        selected={{ label: query.limit, value: query.limit }}
                                        onClickChange={(e) => {
                                            limitChangeHandler(e.value as number);
                                            handleFirstPage();
                                        }}
                                        isBordered
                                        isIcon

                                    />
                                </div>
                            </div>
                            <div className={`${pageClassName}__pagination__number`}>
                                {data?.result?.total ? (
                                    <p>
                                        Show {data?.result?.from} -{" "}
                                        {data?.result?.from + query.limit - 1 < data?.result?.total
                                            ? data?.result?.from + query.limit - 1
                                            : data?.result?.total}{" "}
                                        of {data?.result?.total}
                                    </p>
                                ) : (
                                    <p>Show 00 - 00 of 00</p>
                                )}
                            </div>

                            <div className={`${pageClassName}__pagination__nav`}>
                                {data?.result?.total > query.limit && (
                                    <Pagination
                                        totalData={totalData}
                                        page={query.current}
                                        handleFirstPage={handleFirstPage}
                                        handlePrevPage={handlePrevPage}
                                        handleLastPage={handleLastPage}
                                        handleNextPage={handleNextPage}
                                        renderPageNumbers={renderPageNumbers}
                                    />
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};

export default SaaSToolUnresponsiveUsers;
